import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

const FullScreenLoader = () => (
    <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        height='100vh'
    >
        <CircularProgress />
    </Box>
);

export default FullScreenLoader;